import { Map, Record } from "immutable";

import {
  CrudBuilderState,
  makeCrudBuilderInitialState
} from "seneca-common/utils/apiStates";

import { sectionStatsFetchStateConfig } from "../../../consts";
import { SectionStats } from "./stats";
import SectionStat from "./stats/stat";

export { default as SectionStat } from "./stats/stat";
export type { SectionStatType } from "./stats/stat";
export type { SectionStats };

export type SectionStatsStateSliceType = {
  stats: SectionStats;
  meta: CrudBuilderState | Map<any, any>;
};

const sectionStatsMetaInitialState = makeCrudBuilderInitialState(
  sectionStatsFetchStateConfig
);

const defaultValues: SectionStatsStateSliceType = {
  stats: Map<string, SectionStat>(),
  meta: sectionStatsMetaInitialState
};

export default class SectionStatsStateSlice extends Record(defaultValues) {}
